import Header from '../Components/Header/Header';
import Topics from '../Components/Topics/Topics';

const Home = () => {
    return (
        <div>
            <Header></Header>
            <Topics></Topics>
        </div>
    );
};

export default Home;